import {  createSlice } from "@reduxjs/toolkit";
import { fetchAllStatesAction } from "./action";
import { InitialState } from "./types";

const initialState: InitialState = {
  loading: false,
  allStates: [],
};

//slice here
const utilSlices = createSlice({
  name: "utils",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //add builder for states
    builder.addCase(fetchAllStatesAction.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fetchAllStatesAction.fulfilled, (state, action) => {
      const allStates = action.payload;
      const formattedStates = allStates.map(
        (state: { _id: string; name: string }) => {
          return {
            ...state,
            id: state._id,
          };
        }
      );
      return {
        ...state,
        loading: false,
        allStates: formattedStates,
        error: false,
      };
    });
    builder.addCase(fetchAllStatesAction.rejected, (state) => {
      return {
        ...state,
        loading: true,
        allStates: [],
        error: true,
      };
    });
  },
});

export default utilSlices.reducer;
